import React, { useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import Table from "./Table";
import Form from "./Form";
import { Toast } from "primereact/toast";
export interface IWorkStream {
  id: number;
  tender_ID: number;
  tender_Title: string;
  workstream_Category_ID: number;
  category_Name: string;
  title: string;
  description: string;
  assigned_To: string;
  assigned_To_ID: number;
  assigned_By: string;
  assigned_At: Date | null;
  deadline_Date?: Date | null;
  status?: string;
  rfp_Description?: string;
  tender_Published_Date?: Date;
  due_Date?: Date;
  assigned_To_Pro?: string;
  assigned_ToBM?: string;
  tender_Client?: string;
  vendor_Company?: string;
  client_Category?: string;
  service_Department_Name?: string;
  added_By_Name?: string;
  hasDocument?: boolean;
}
export interface IModel {
  open: boolean;
  singleData: IWorkStream;
}
const EmptyWorkStream: IWorkStream = {
  id: 0,
  tender_ID: 0,
  tender_Title: "",
  workstream_Category_ID: 0,
  category_Name: "",
  title: "",
  description: "",
  assigned_To: "",
  assigned_To_ID: 0,
  assigned_By: "",
  assigned_At: null,
  deadline_Date: null,
  status: "",
};
const WorkStreamList = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyWorkStream, open: false } as IModel);
  const [reload, setReload] = useState<boolean>(false);
  const toast = useRef<any>();
  const hideDialog = () => {
    setModal({ singleData: EmptyWorkStream, open: false });
  };

  return (
    <>
      <Table permission={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload} />
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default WorkStreamList;
